import { render, staticRenderFns } from "./AnnounceModal.vue?vue&type=template&id=2a349cb4"
import script from "./AnnounceModal.vue?vue&type=script&lang=js"
export * from "./AnnounceModal.vue?vue&type=script&lang=js"
import style0 from "./AnnounceModal.vue?vue&type=style&index=0&id=2a349cb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports